export const QualityCriteria = [
  {
    name: 'A. Learning Outcomes',
    heading: 'How to create Learning Outcomes',
    headingLink:
      'https://openlearning.forumbee.com/t/x1g29n/1-start-with-learning-outcomes',
    example: 'Examples',
    exampleLink: 'https://www.showcase.openlearning.com/outcomes',
    id: 'A',
    criteriaHeaders: [
      'Your Learning Outcomes:',
      'Achieved',
      'Not Yet Achieved',
    ],
    criteriaRows: [
      {
        caption:
          '1. Begin with a verb and articulate what learners will know or be able to do by the end of the course',
        id: 'a-learning-outcomes',
        toolTip:
          'Tip: Decide what you want students to know or be able to do by the end of your course. Then, articulate these as outcome statements that start with a verb',
      },
    ],
  },
  {
    name: 'B. Modules',
    heading: 'How to create Modules',
    headingLink: 'https://openlearning.forumbee.com/t/18pdl6/course-modules',
    example: 'Examples',
    exampleLink: 'https://www.showcase.openlearning.com/modules',
    id: 'B',
    criteriaHeaders: ['Your Modules:', 'Achieved', 'Not Yet Achieved'],
    criteriaRows: [
      {
        caption: '1. Are relevant to learning outcomes',
        id: 'b-learning-outcomes',
        toolTip:
          'Tip: Make sure your module topics are relevant to the learning outcomes you have set for the course.',
      },
      {
        caption: '2. Are well structured with a relevant and logical flow',
        id: 'b-relevant-logical',
        toolTip:
          'Tip: Make sure your module topics are relevant to the learning outcomes you have set for the course.',
      },
      {
        caption: '3. Build topic knowledge appropriately',
        id: 'b-topic-knowledge',
        toolTip:
          'Tip: Make sure your modules are sequenced in a way that topic knowledge is developed for students appropriately.',
      },
    ],
  },
  {
    name: 'C. Content and Resources',
    heading: 'How to create Content and Resources',
    headingLink:
      'https://openlearning.forumbee.com/t/x1pdfx/content-and-resources',
    example: 'Examples',
    exampleLink: 'https://www.showcase.openlearning.com/content',
    id: 'C',
    criteriaHeaders: [
      'Your Content and Resources:',
      'Achieved',
      'Not Yet Achieved',
    ],
    criteriaRows: [
      {
        caption: '1. Are relevant to learning outcomes',
        id: 'c-learning-outcomes',
        toolTip:
          'Tip: Ensure your content and resources are relevant to and will help learners achieve the learning outcomes',
      },
      {
        caption: '2. Are relevant to module topics',
        id: 'c-module-topics',
        toolTip:
          'Tip: Include content and resources that are relevant to each module topic',
      },
      {
        caption:
          '3. Are scaffolded and sequenced on pages in a way that maximises learning impact and student engagement',
        id: 'c-learning-impact',
        toolTip:
          'Tip: Ensure the pages within each module are sequenced appropriately and scaffold learners to develop their understanding of the module topics',
      },
      {
        caption:
          '4. Use a variety of resources in meaningful ways (e.g video, text, images, audio)',
        id: 'c-variety-resources',
        toolTip:
          'Tip: Use a variety of resources that would engage learners with the topic (e.g. video, text, images, audio)',
      },
    ],
  },
  {
    name: 'D. Learning Activities',
    heading: 'How to create Learning Activities',
    headingLink:
      'https://openlearning.forumbee.com/t/80pdl0/5-designing-great-activities',
    example: 'Examples',
    exampleLink: 'https://www.showcase.openlearning.com/activities',
    id: 'D',
    criteriaHeaders: [
      'Your Learning Activities:',
      'Achieved',
      'Not Yet Achieved',
    ],
    criteriaRows: [
      {
        caption: '1. Are relevant to learning outcomes',
        id: 'd-learning-outcomes',
        toolTip:
          'Tip: Activities in your course should support learners to achieve the learning outcomes',
      },
      {
        caption: '2. Are relevant to course and page topics',
        id: 'd-relevance',
        toolTip:
          'Tip: Ensure all activities are relevant to the course, module and page topics that they appear in',
      },
      {
        caption:
          "3. Capture learners' interest, intrinsic motivation and foster enjoyment in learning",
        id: 'd-interest',
        toolTip:
          'Tip: Include activities that will excite, inspire and motivate students to enjoy your course',
      },
      {
        caption:
          '4. Enable interaction and social learning among learners (e.g discussions, sharing, group work, projects)',
        id: 'd-interaction',
        toolTip:
          'Tip: Include activities that encourage students to connect with other learners through activities such as discussions, sharing, group work, collaborative activities, projects',
      },
      {
        caption:
          '5. Enable students to connect concepts authentically to their own world.',
        id: 'd-concepts',
        toolTip:
          'Tip: Include activities that support learners to connect what they are learning to their own world',
      },
      {
        caption: '6. Allow students to reflect on their learning',
        id: 'd-relection',
        toolTip:
          'Tip: Include activities that enable students to reflect on their learning and the concepts within the course',
      },
      {
        caption:
          '7. Invite learners to apply concepts in personally meaningful ways',
        id: 'd-apply-concepts',
        toolTip:
          'Tip: Include activities that enable learners to apply the concepts they are learning in meaningful ways',
      },
      {
        caption:
          '8. Encourage self-expression and open-ended contribution (e.g. using share widgets such as share text, share an image, share a file, post a comment)',
        id: 'd-self-expression',
        toolTip:
          'Tip: Include activities that enable learners to apply the concepts they are learning in meaningful ways',
      },
    ],
  },
  {
    name: 'E. Course Homepage',
    heading: 'How to create the Course Homepage',
    headingLink:
      'https://openlearning.forumbee.com/t/x1pdkm/setting-up-your-course-homepage',
    example: 'Examples',
    exampleLink: 'https://www.showcase.openlearning.com/homepage',
    id: 'E',
    criteriaHeaders: ['Your Course Homepage:', 'Achieved', 'Not Yet Achieved'],
    criteriaRows: [
      {
        caption:
          '1. Contains a message and/or tone that would make learners feel welcomed to the course community',
        id: 'e-community',
        toolTip:
          'Tip: Make your course homepage welcoming by using a friendly tone and writing a message that welcomes learners into the course community',
      },
      {
        caption:
          "2. Would attract learners' attention and interest through use of relevant examples, analogies, anecdotes etc",
        id: 'e-interest',
        toolTip:
          'Tip: Make your homepage interesting and engaging for learners, by including topic-relevant information that is interesting or engaging',
      },
      {
        caption:
          '3. Contains an ice-breaker/welcome activity that is relevant to learners, invites them to share and fosters a sense of rapport and community',
        id: 'e-welcome-activity',
        toolTip:
          'Tip: Include a welcome activity for learners that help them to build rapport with each other quickly. Ask them to say hello along with an easy (and fun!) activity to get them used to sharing and connecting with each other',
      },
    ],
  },
  {
    name: 'F. Course Look and Feel',
    heading: 'How to create the Course Look and Feel',
    headingLink:
      'https://openlearning.forumbee.com/t/63j842/1-create-an-inviting-look-and-feel',
    id: 'F',
    example: 'Examples',
    exampleLink: 'https://www.showcase.openlearning.com/look-feel',
    criteriaHeaders: [
      'Your Course Look and Feel:',
      'Achieved',
      'Not Yet Achieved',
    ],
    criteriaRows: [
      {
        caption: '1. Uses images throughout that are relevant and engaging',
        id: 'f-relevance',
        toolTip:
          'Tip: Include relevant images, icons, infographics and other visual elements to create a positive feeling for students',
      },
      {
        caption:
          '2. Utilises page designs that are visually appealling and logically sequenced',
        id: 'f-page-design',
        toolTip:
          'Tip: Make your pages sequenced in a way that is appealing and easy for students to understand',
      },
      {
        caption:
          '3. Utilises the tone, instructions and explanations throughout the course in ways that are friendly, clear and build rapport with learners',
        id: 'f-friendly',
        toolTip:
          'Tip: Ensure your tone, instructions and language throughout the course are friendly and easy to understand',
      },
      {
        caption: '4. Is free from grammar/spelling errors',
        id: 'f-grammer',
        toolTip:
          'Tip: Ensure your writing is free from grammar/spelling errors',
      },
    ],
  },
  {
    name: 'G. Course Promo Page',
    heading: 'How to create the Course Promo Page',
    headingLink:
      'https://openlearning.forumbee.com/t/m2j898/3-crafting-your-course-promo-page',
    id: 'G',
    example: 'Examples',
    exampleLink: 'https://www.showcase.openlearning.com/promo-page',
    criteriaHeaders: [
      'Your Course Promo Page:',
      'Achieved',
      'Not Yet Achieved',
    ],
    criteriaRows: [
      {
        caption: '1. Has a relevant and enticing course title',
        id: 'g-relevant',
        toolTip:
          'Tip: Make your course title catchy, relevant and enticing for learners',
      },
      {
        caption: '2. Has a relevant and enticing course thumbnail image ',
        id: 'g-enticing',
        toolTip:
          'Tip: Make your course thumbnail image relevant to your course topic and inviting for learners',
      },
      {
        caption: '3. Has a relevant and engaging course promo video/image',
        id: 'e-engaging',
        toolTip:
          'Tip: Make your course promo image or video relevant and engaging, to connect with learners',
      },
      {
        caption:
          '4. Has an inviting and relevant course banner image that includes the course title',
        id: 'e-good-banner',
        toolTip:
          'Tip: Make your course banner a relevant and inviting image that includes the course title',
      },
      {
        caption:
          '5. Contains key information that students need to know to enrol',
        id: 'e-information',
        toolTip:
          'Tip: Include a course summary that contains the key information that students need to know about your course: the what, how and why',
      },
      {
        caption: '6. Is well written in an engaging manner',
        id: 'e-well-written',
        toolTip:
          'Tip: Write your course summary in a way that is interesting for potential students. What is unique and exciting about your course?',
      },
    ],
  },
];

export const MAX_REVIEW_CRITERIA_CHECK = 29;

// Review states
export const COURSE_NOT_LISTED = 'COURSE_NOT_LISTED';
export const COURSE_UNDER_REVIEW = 'COURSE_UNDER_REVIEW';
export const COURSE_REQ_IMPROVEMENT = 'COURSE_REQ_IMPROVEMENT';
export const COURSE_LISTED = 'COURSE_LISTED';
export const OL_STAFF_REVIEW = 'OL_STAFF_REVIEW';

// Review actions
export const REQUEST_TO_BE_LISTED = 'REQ_TO_BE_LISTED';
export const CANCEL_REQUEST = 'CANCEL_REQUEST';
export const REQUEST_TO_BE_LISTED_AFTER_IMPROVEMENT =
  'REQUEST_TO_BE_LISTED_AFTER_IMPROVEMENT';
export const REQUEST_TO_UNLIST = 'REQUEST_TO_UNLIST';
// OL Staff actions
export const OL_STAFF_REVIEW_COURSE_LISTED = 'OL_STAFF_REVIEW_COURSE_LISTED';
export const OL_STAFF_REVIEW_COURSE_NEEDS_IMPROVEMENT =
  'OL_STAFF_REVIEW_COURSE_NEEDS_IMPROVEMENT';

export const COURSE_QUALITY_CRITERIA_LINK =
  'https://help.openlearning.com/media/download/k9lpc7/OpenLearning%20Course%20Quality%20Criteria%20July%202020%20(1).pdf';

export const getReviewBannerData = (reviewState) => {
  switch (reviewState) {
    case 'COURSE_NOT_LISTED':
      return {
        btnCaption: 'Request to be listed',
        btnColor: 'orange',
        bannerText: `<p> If you would like your course to be listed as an OpenCred, please send an email to <a href="mailto:opencreds@openlearning.com">opencreds@openlearning.com</a> with the information detailed in the <a target="_blank" rel="noopener noreferrer" href="${COURSE_QUALITY_CRITERIA_LINK}">Course Quality Criteria</a>.</p>
          <p> Course Status: Your course is <strong> not listed </strong> on our <a target="_blank" href="https://www.openlearning.com/courses/"> Course Marketplace.</a> </p>`,
        action: 'REQUEST_TO_BE_LISTED',
      };
    case 'COURSE_UNDER_REVIEW':
      return {
        btnCaption: 'Cancel Request',
        btnColor: 'grey',
        bannerText:
          '<p> Course Status: Your course is <strong> under review </strong> by the OpenLearning Team </p>',
        action: 'CANCEL_REQUEST',
      };
    case 'COURSE_REQ_IMPROVEMENT':
      return {
        btnCaption: 'Request to be listed',
        btnColor: 'orange',
        bannerText:
          '<p> Course Status: Your course <strong> requires improvement </strong>. </p> <p> Check the results below, make the suggested changes and re-submit for review </p>',
        action: 'REQUEST_TO_BE_LISTED',
      };
    case 'COURSE_LISTED':
      return {
        btnCaption: 'Unlist',
        btnColor: 'grey',
        bannerText:
          '<p> Course Status: Congratulations! Your course is <strong> listed in our <a target="_blank" href="https://www.openlearning.com/courses/"> Course Marketplace.</a> </strong> If you don\'t want your course to be listed anymore, click "Unlist" below </p>',
        action: 'REQUEST_TO_UNLIST',
      };
    default:
      return {
        btnCaption: 'Request to be listed',
        btnColor: 'orange',
        bannerText: `<p> If you would like your course to be listed as an OpenCred, please send an email to <a href="mailto:opencreds@openlearning.com">opencreds@openlearning.com</a> with the information detailed in the <a target="_blank" rel="noopener noreferrer" href="${COURSE_QUALITY_CRITERIA_LINK}">Course Quality Criteria</a>.</p>
          <p> Course Status: Your course is <strong> not listed </strong> on OpenLearning Course Marketplace </p>`,
      };
  }
};

export const reviewStateReducer = (action) => {
  switch (action) {
    case 'REQUEST_TO_BE_LISTED':
      return COURSE_UNDER_REVIEW;
    case 'CANCEL_REQUEST':
      return COURSE_NOT_LISTED;
    case 'COURSE_REQ_IMPROVEMENT':
      return COURSE_UNDER_REVIEW;
    case 'REQUEST_TO_UNLIST':
      return COURSE_NOT_LISTED;
    case 'OL_STAFF_REVIEW_COURSE_LISTED':
      return COURSE_LISTED;
    case 'OL_STAFF_REVIEW_COURSE_NEEDS_IMPROVEMENT':
      return COURSE_REQ_IMPROVEMENT;
    default:
      return COURSE_NOT_LISTED;
  }
};

export const isAllCriteriaChecked = (review) => {
  let reviewChecked = 0;
  Object.keys(review).forEach((key) => {
    const reviewItem = review[key];
    if (!(reviewItem.achieved === false && reviewItem.notAchieved === false)) {
      reviewChecked += 1;
    }
  });
  if (reviewChecked !== MAX_REVIEW_CRITERIA_CHECK) {
    return false;
  } else {
    return true;
  }
};

export const isCourseNeedsImprovement = (review) => {
  let criteriaAchieved = 0;
  Object.keys(review).forEach((key) => {
    const reviewItem = review[key];
    if (reviewItem.achieved === true && reviewItem.notAchieved === false) {
      criteriaAchieved += 1;
    }
  });
  if (criteriaAchieved !== MAX_REVIEW_CRITERIA_CHECK) {
    return true;
  } else {
    return false;
  }
};

const getCriteria = (sectionId) => {
  const crt = QualityCriteria.filter((criteria) => criteria.id === sectionId);
  return crt[0];
};

export const getIdsInSection = (sectionId) => {
  const criteria = getCriteria(sectionId);
  return criteria.criteriaRows.map((row) => row.id);
};
